module.exports = __webpack_public_path__ + "56583c2363a20436f7448d9b963c0463.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Rubik/Rubik-MediumItalic.ttf
// module id = 1273
// module chunks = 0